import { render, staticRenderFns } from "./ViewSettingsSlice.vue?vue&type=template&id=4ab6042c&scoped=true&"
import script from "./ViewSettingsSlice.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsSlice.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsSlice.vue?vue&type=style&index=0&id=4ab6042c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab6042c",
  null
  
)

export default component.exports